import React, {useState, useEffect} from 'react'
import {Form, FormInput, FormGroup} from 'semantic-ui-react'

export const SubOrden =({options, index, handleChange})=>{
    const [product, setProduct]= useState('')
    const [quantity, setQuantity]=useState(0)
    let enEnvio = 0
    let entregadas = 0
    let status = 'solicitado'

    useEffect(()=>{
        handleChange(index, {product, quantity, enEnvio, entregadas, status})
    }, [product, quantity, enEnvio, entregadas, status])
    
    const handleQuantity = (e, {value}) => {
        const inputValue = value
        if (/^\d*\.?\d*$/.test(inputValue)) {
            setQuantity(parseInt(inputValue));
        }
    }
    const productSelected = (e, data) => {
        setProduct(data.options[data.value].text)
    }
    return (
        <FormGroup>
            <Form.Dropdown
                label='Herramienta' 
                placeholder='Herramienta'
                selection
                search
                options={options}
                onChange={productSelected}
            />
            <FormInput
                label='Cantidad'
                type="number"
                className="inputInt"
                name='quantity'
                onChange={handleQuantity}
                value={quantity}
                style={{ width: '5em' }}
            />
        </FormGroup>
    )
}